module.exports = __webpack_public_path__ + "img/441.e678111c.jpg";